import { Application } from '@splinetool/runtime'

export const spline = () => {

	let canvas = document.getElementById('canvas')

	if (!canvas) return

	let app = new Application(canvas)

	app.load('https://prod.spline.design/kmPtHhLADpNjA6q8/scene.splinecode')

}

export default () => { }